// extracted by mini-css-extract-plugin
export default {"DropHover":"FileDropZoneWrapper_DropHover__ppaIj"};